import React from 'react';
import { X } from 'lucide-react';
import { Text } from '../typography/Text';
import { Heading } from '../typography/Heading';

interface PaywallProps {
  isOpen: boolean;
  onClose: () => void;
}

export function Paywall({ isOpen, onClose }: PaywallProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-8 max-w-md w-full mx-4">
        <div className="flex justify-between items-center mb-6">
          <Heading level={2} className="text-2xl">
          Save time, land the job!
          </Heading>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-6">
          <div>
            <Text className="text-slate-light mb-4">
            Upgrade now for unlimited cover letters.
            </Text>
          </div>

          <div className="space-y-4">
            <a
              href="/pricing"
              className="block w-full text-center bg-success text-white py-3 rounded-lg hover:bg-success-hover transition-colors"
            >
              Go Premium
            </a>
          </div>

          <Text className="text-sm text-slate-light text-center">
            All plans come with a 14-day money-back guarantee
          </Text>
        </div>
      </div>
    </div>
  );
}